import React, { useState } from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import { Home, ExpandMore, ExpandLess } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import { useDarkMode } from '../context/DarkModeContext';

const faqs = [
  {
    q: 'What is text-json.com?',
    a: 'text-json.com is a free online toolkit for comparing, formatting, and analyzing text and JSON data. It helps you quickly spot differences, validate JSON, and perform text utilities.'
  },
  {
    q: 'Is my data safe?',
    a: 'Yes! All processing happens in your browser. Your data never leaves your device and is not stored or sent to any server.'
  },
  {
    q: 'Can I use this on mobile?',
    a: 'Absolutely. The site is fully responsive and works great on mobile, tablet, and desktop.'
  },
  {
    q: 'How do I report a bug or request a feature?',
    a: 'You can contact us using the Contact Us link in the footer, or email contact@text-json.com.'
  },
  {
    q: 'Is text-json.com free to use?',
    a: 'Yes, all features are completely free to use.'
  }
];

export default function FaqPage() {
  const navigate = useNavigate();
  const { darkMode, toggleDarkMode } = useDarkMode();
  const [openIndexes, setOpenIndexes] = useState([]);

  const handleToggle = (idx) => {
    setOpenIndexes((prev) =>
      prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
    );
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', color: 'text.primary', p: 3, display: 'flex', flexDirection: 'column', position: 'relative' }}>
      {/* Dark mode toggle in top right corner */}
      <button
        onClick={toggleDarkMode}
        className="dark-mode-toggle"
        style={{ 
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 1000,
          color: '#fff',
          fontSize: '1rem',
          padding: '8px 16px',
          borderRadius: '4px',
          backgroundColor: '#388e3c',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '40px'
        }}
        onMouseEnter={(e) => e.target.style.backgroundColor = '#2e7d32'}
        onMouseLeave={(e) => e.target.style.backgroundColor = '#388e3c'}
      >
        <span className="dark-mode-text">
          {darkMode ? '☀️ Light Mode' : '🌙 Dark Mode'}
        </span>
        <span className="dark-mode-icon">
          {darkMode ? '☀️' : '🌙'}
        </span>
      </button>
      <Button
        startIcon={<Home />}
        onClick={() => navigate('/')}
        sx={{ 
          color: '#fff',
          textDecoration: 'none',
          fontSize: '1rem',
          padding: '8px 16px',
          borderRadius: '4px',
          bgcolor: '#388e3c',
          textTransform: 'none',
          width: { xs: '100%', sm: 'auto' },
          alignSelf: 'flex-start',
          mb: 3,
          mt: { xs: 7, sm: 0 },
          '&:hover': {
            bgcolor: '#2e7d32'
          }
        }}
      >
        Home
      </Button>
              <Typography variant="h4" sx={{ color: '#006400', fontWeight: 'bold', mb: 2, textAlign: 'center' }}>
        Frequently Asked Questions
      </Typography>
      <Box sx={{ maxWidth: 700, mx: 'auto', width: '100%' }}>
        {faqs.map((faq, idx) => {
          const open = openIndexes.includes(idx);
          return (
            <Box key={idx} sx={{ mb: 3, p: 2, borderRadius: 2, bgcolor: 'background.paper', boxShadow: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleToggle(idx)}>
                <Typography variant="h6" sx={{ color: '#388e3c', fontWeight: 600, mb: 0, flex: 1 }}>
                  {faq.q}
                </Typography>
                <IconButton size="small" sx={{ color: '#388e3c' }}>
                  {open ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              </Box>
              {open && (
                <Typography variant="body1" sx={{ color: 'text.primary', mt: 1 }}>
                  {faq.a}
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>
      <Footer />
    </Box>
  );
} 